<template>
  <card>
    <h4 slot="header" class="card-title">Yeni Kullanıcı</h4>
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      labelAlign="left"
    >
      <a-form-model-item ref="first_name" label="İsim" prop="first_name">
        <a-input
          placeholder="İsim"
          v-model="form.first_name"
          @blur="() => { $refs.first_name.onFieldBlur(); }"
        />
      </a-form-model-item>

      <a-form-model-item ref="last_name" label="Soyisim" prop="last_name">
        <a-input
          placeholder="Soyisim"
          v-model="form.last_name"
          @blur="() => { $refs.last_name.onFieldBlur(); }"
        />
      </a-form-model-item>

      <a-form-model-item ref="email" label="Email" prop="email">
        <a-input
          v-model="form.email"
          placeholder="Email"
          @blur="() => { $refs.email.onFieldBlur(); }"
        />
      </a-form-model-item>

      <a-form-model-item has-feedback label="Şifre" prop="password">
        <a-input placeholder="Şifre" v-model="form.password" type="password" autocomplete="off" />
      </a-form-model-item>

      <a-form-model-item has-feedback label="Onayla" prop="checkPass">
        <a-input placeholder="Şifre Tekrarı" v-model="form.checkPass" type="password" autocomplete="off" />
      </a-form-model-item>

      <a-form-model-item label="Yetki Tipi" prop="roleType">
        <a-select
          show-search
          allowClear
          placeholder="Yetki tipi seçiniz"
          v-model="selectedRoleType"
          option-filter-prop="children"
          @change="onRoleTypeChange"
        >
          <a-select-option
            v-for="st in availableSegmentTypes"
            :value="'segment_' + st.id"
            :key="'st_' + st.id"
          >
            {{ st.name + ' Yöneticisi' }}
          </a-select-option>
          <a-select-option v-if="isCurrentUserOrgAdmin" value="organizationAdmin">
            Organizasyon Yöneticisi
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item
        v-if="selectedSegmentTypeId && !isSelectedTypeOwnType"
        :label="selectedSegmentTypeName + ' Seçimi'"
        prop="managed_segment_id"
      >
        <a-select
          show-search
          allowClear
          :placeholder="selectedSegmentTypeName + ' seçiniz'"
          v-model="form.managed_segment_id"
          option-filter-prop="children"
          :filter-option="filterOption"
        >
          <a-select-option
            v-for="seg in segmentsForSelectedType"
            :value="seg.id"
            :key="seg.id"
          >
            {{ seg.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item
        v-if="isSelectedTypeOwnType"
        :label="selectedSegmentTypeName + ' Seçimi'"
      >
        <span>{{ ownSegment.name }} (yönettiğiniz {{ selectedSegmentTypeName }} olarak otomatik atanır)</span>
      </a-form-model-item>

      <a-form-model-item label="Kumbara Atama" prop="moneybox_assignment">
        <a-select
          show-search
          mode="multiple"
          label-in-value
          option-filter-prop="children"
          style="width: 100%"
          placeholder="Kumbara seçiniz"
          :filter-option="filterOption"
          @change="handleMoneyboxChange"
        >
          <a-select-option v-for="d in moneyboxList" :value="d.value" :key="d.value">
            {{ d.text }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item :wrapper-col="{ span: 14, offset: 5 }">
        <a-button :loading="loading" type="primary" @click="onSubmit">
          Oluştur
        </a-button>
        <a-button style="margin-left: 10px;" @click="resetForm">
          Sıfırla
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </card>
</template>

<script>
import { mapState } from 'vuex'
import Card from 'src/components/Cards/Card.vue'

function decodeJWT(token) {
  try {
    return JSON.parse(atob(token.split('.')[1]))
  } catch (_) {
    return null
  }
}

export default {
  components: { Card },

  mounted() {
    this.$store.dispatch('Moneybox/requestMoneyboxList')
    this.$store.dispatch('Segments/requestSegmentIndex').then((a) => {
      this.$store.dispatch('Segments/requestSegmentTypeIndex').then((b) => {
        this.segments = a.segments
        this.segmentTypes = b.segmentTypes
      })
    })
  },

  computed: {
    ...mapState({
      moneyboxes: (state) => state.Moneybox.moneyboxes,
    }),

    moneyboxList() {
      if (!this.moneyboxes.moneyboxes) return []
      return this.moneyboxes.moneyboxes.map((item) => ({
        text: item.name,
        value: item.id,
      }))
    },

    sortedSegmentTypes() {
      return this.segmentTypes.slice().sort((a, b) => a.rank - b.rank)
    },

    rootRank() {
      if (!this.segmentTypes.length) return null
      return Math.min(...this.segmentTypes.map((t) => t.rank))
    },

    // The segment the logged-in segmentAdmin themself manages, looked up
    // from the (already scope-filtered by the backend) segments list via
    // the managed_segment_id carried in their JWT. Null for organizationAdmin,
    // who isn't tied to a single segment.
    ownSegment() {
      if (this.isCurrentUserOrgAdmin) return null
      const managedId = this.currentUserClaims && this.currentUserClaims.managed_segment_id
      if (!managedId) return null
      return this.segments.find((s) => s.id === managedId) || null
    },

    ownSegmentTypeRank() {
      if (!this.ownSegment) return null
      const st = this.segmentTypes.find((t) => t.id === this.ownSegment.segment_type_id)
      return st ? st.rank : null
    },

    // The role types this admin is allowed to hand out: the organization's
    // root type (e.g. "Merkez") is never offered, since organizationAdmin
    // already represents that level. A segmentAdmin may only create a peer
    // for their own segment (auto-assigned) or an admin for the segment
    // type directly beneath theirs (which needs a picker, scoped to their
    // own subtree by the backend).
    availableSegmentTypes() {
      const nonRoot = this.sortedSegmentTypes.filter((t) => t.rank !== this.rootRank)
      if (this.isCurrentUserOrgAdmin) return nonRoot
      if (this.ownSegmentTypeRank === null) return []
      return nonRoot.filter(
        (t) => t.rank === this.ownSegmentTypeRank || t.rank === this.ownSegmentTypeRank + 1
      )
    },

    isSelectedTypeOwnType() {
      return !!(
        this.ownSegment &&
        this.selectedSegmentTypeId &&
        this.selectedSegmentTypeId === this.ownSegment.segment_type_id
      )
    },

    selectedSegmentTypeId() {
      if (!this.selectedRoleType || !this.selectedRoleType.startsWith('segment_')) return null
      return parseInt(this.selectedRoleType.replace('segment_', ''), 10)
    },

    selectedSegmentTypeName() {
      if (!this.selectedSegmentTypeId) return ''
      const st = this.segmentTypes.find((t) => t.id === this.selectedSegmentTypeId)
      return st ? st.name : ''
    },

    segmentsForSelectedType() {
      if (!this.selectedSegmentTypeId) return []
      return this.segments.filter((s) => s.segment_type_id === this.selectedSegmentTypeId)
    },

    currentUserClaims() {
      const token = localStorage.getItem('access_token')
      if (!token) return null
      return decodeJWT(token)
    },

    isCurrentUserOrgAdmin() {
      const claims = this.currentUserClaims
      return !!(claims && Array.isArray(claims.roles) && claims.roles.includes('organizationAdmin'))
    },
  },

  data() {
    const validatePass = (rule, value, callback) => {
      if (!value) {
        callback(new Error('Şifre alanı boş bırakılamaz.'))
      } else if (value.length < 3) {
        callback(new Error('Şifre alanı min 3 karakter uzunluğunda olmalıdır.'))
      } else {
        if (this.form.checkPass !== '') this.$refs.ruleForm.validateField('checkPass')
        callback()
      }
    }

    const validatePass2 = (rule, value, callback) => {
      if (!value) {
        callback(new Error('Şifre alanı boş bırakılamaz.'))
      } else if (value !== this.form.password) {
        callback(new Error('Şifre alanlarındaki veriler eşleşmelidir.'))
      } else {
        callback()
      }
    }

    return {
      segments: [],
      segmentTypes: [],
      selectedRoleType: undefined,
      selected_moneyboxes: [],
      loading: false,
      labelCol: { span: 5 },
      wrapperCol: { span: 14 },
      form: {
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        checkPass: '',
        managed_segment_id: undefined,
      },
      rules: {
        password: [{ required: true, validator: validatePass, trigger: 'change' }],
        checkPass: [{ required: true, validator: validatePass2, trigger: 'change' }],
        first_name: [
          { required: true, message: 'İsim alanını boş bırakmayınız', trigger: 'blur' },
          { min: 2, max: 50, message: 'İsim alanı 2-50 karakter arasında olmalıdır', trigger: 'blur' },
        ],
        last_name: [
          { required: true, message: 'Soyisim alanını boş bırakmayınız', trigger: 'blur' },
          { min: 2, max: 50, message: 'Soyisim alanı 2-50 karakter arasında olmalıdır', trigger: 'blur' },
        ],
        email: [
          { required: true, message: 'Email alanını boş bırakmayınız', trigger: 'blur' },
          { type: 'email', message: 'Geçerli bir email adresi giriniz', trigger: 'blur' },
        ],
      },
    }
  },

  methods: {
    onRoleTypeChange() {
      this.form.managed_segment_id = this.isSelectedTypeOwnType ? this.ownSegment.id : undefined
    },

    handleMoneyboxChange(value) {
      this.selected_moneyboxes = value
    },

    filterOption(input, option) {
      return option.componentOptions.children[0].text
        .toLowerCase()
        .indexOf(input.toLowerCase()) >= 0
    },

    onSubmit() {
      const self = this
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return

        let roles = ''
        if (self.selectedRoleType === 'organizationAdmin') {
          roles = 'organizationAdmin'
        } else if (self.selectedRoleType) {
          roles = 'segmentAdmin'
        }

        const payload = {
          ...self.form,
          roles,
          managed_segment_id: roles === 'segmentAdmin' ? self.form.managed_segment_id : 0,
        }

        self.loading = true
        self.$store.dispatch('Users/requestUserCreate', {
          ...payload,
          selectedSegments: [],
        }).then((user) => {
          self.$notification.success({
            message: 'Kullanıcı Ekleme',
            description: 'Kullanıcı başarılı bir şekilde oluşturuldu.',
          })
          if (self.selected_moneyboxes.length) {
            self.$store.dispatch('Users/requestUserMoneyboxAssignmentCreate', {
              user_id: user.id,
              selected_moneyboxes: self.selected_moneyboxes,
            })
          }
          self.$router.push('/admin/users/')
        }).catch(() => {
          self.$notification.error({
            message: 'Kullanıcı Ekleme',
            description: 'Kullanıcı eklenirken bir hata oluştu.',
          })
        }).finally(() => {
          self.loading = false
        })
      })
    },

    resetForm() {
      this.$refs.ruleForm.resetFields()
      this.selectedRoleType = undefined
    },
  },
}
</script>
